module.exports = __webpack_public_path__ + "static/media/chat-icon-v2.e682d91a.svg";